import { listItemWrapper, pagedListWrapper } from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type { Member } from '../../types/shared'
import type { Achievement } from './types'

export default {
  factory: ({ apiClient, version }) => {
    const { getItem: getAchievement } = listItemWrapper<Achievement>(
      apiClient,
      {
        path: `/api/v${version}/achievements`
      }
    )

    const achievements = pagedListWrapper<'id', Achievement>()(apiClient, {
      path: `/api/v${version}/achievements`,
      idKey: 'id'
    })

    const memberAchievements = pagedListWrapper<
      'id',
      Achievement,
      { id: Member['id'] }
    >()(apiClient, {
      path: (_query, { id }) => `/api/v${version}/achievements/member/${id}`,
      idKey: 'id'
    })

    return { getAchievement, achievements, memberAchievements }
  }
} satisfies Starter
